import { ProductsSlider } from "@/components/shared/products-slider"
import {
  getProductsByCategory,
  getProductsByIds,
  type WooCommerceProduct,
} from "@/services/woo-commerce-service"

export type MoreProductsSource = "upsell" | "related" | "category" | "none"

export interface MoreProductsResult {
  products: WooCommerceProduct[]
}

export interface MoreProductsInput {
  productId: number
  upsellIds?: number[]
  relatedIds?: number[]
  categoryId?: number
  limit?: number
}

export async function getRelatedProducts({
  productId,
  upsellIds,
  relatedIds,
  categoryId,
  limit = 4,
}: MoreProductsInput): Promise<WooCommerceProduct[]> {
  let ids: number[] = []

  if (upsellIds?.length) {
    ids = upsellIds.slice(0, limit)
  }

  if (relatedIds?.length) {
    ids = relatedIds.slice(0, limit)
  }

  if (ids.length) {
    const products = await getProductsByIds(ids)

    return products
  }

  if (categoryId) {
    const products = await getProductsByCategory({
      categoryId,
      excludeProductId: productId,
      limit,
    })

    return products
  }

  return []
}

export const RelatedProducts = async ({
  product,
}: {
  product: WooCommerceProduct
}) => {
  const relatedProducts = await getRelatedProducts({
    productId: product.id,
    upsellIds: product.upsell_ids,
    relatedIds: product.related_ids,
    categoryId: product.categories?.[0]?.id,
    limit: 8,
  })

  return (
    <section aria-label='Produtos relacionados' className='w-full'>
      <h2 className='mb-6 font-semibold text-2xl'>Produtos Relacionados</h2>

      <ProductsSlider
        products={relatedProducts}
        title='Produtos Relacionados'
      />
    </section>
  )
}
